// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_gW","galleryItem_borderTopRadius":"c-n_gX","galleryItem__image":"c-n_gY","galleryItem__image_withBlur":"c-n_gZ"};